import type { StatCardProps } from './StatCard';

export const statCardData: StatCardProps[] = [
  {
    title: 'Users',
    value: '144k',
    data: [200, 24, 220, 260, 240, 380, 100, 240, 280, 240],
  },
  {
    title: 'Conversions',
    value: '325k',
    data: [1640, 1250, 970, 1130, 1050, 900, 720, 1080, 900, 450],
  },
  {
    title: 'Event count',
    value: '200k',
    data: [500, 400, 510, 530, 520, 600, 530, 520, 510, 730],
  },
];
